import React from 'react';
import { Phone, Monitor, Code } from 'lucide-react';

interface MarcaPersonalProps {
  variant?: 'footer' | 'splash' | 'about';
  className?: string;
}

export const MarcaPersonal: React.FC<MarcaPersonalProps> = ({ 
  variant = 'footer', 
  className = '' 
}) => {
  
  if (variant === 'splash') {
    return (
      <div className={`bg-gradient-to-r from-blue-600 to-purple-600 text-white p-8 rounded-lg shadow-xl ${className}`}>
        <div className="text-center">
          <div className="flex justify-center mb-4">
            <div className="bg-white p-3 rounded-full">
              <Monitor className="h-8 w-8 text-blue-600" />
            </div>
          </div>
          <h2 className="text-2xl font-bold mb-2">Sistema Desarrollado por</h2>
          <h1 className="text-3xl font-extrabold mb-2">JOHN ROMAN</h1>
          <p className="text-xl mb-4 opacity-90">Tu Lugar Inteligente</p>
          <div className="flex items-center justify-center space-x-2">
            <Phone className="h-5 w-5" />
            <a 
              href="tel:931398916" 
              className="text-xl font-semibold hover:underline"
            >
              931398916
            </a>
          </div>
          <p className="mt-4 text-sm opacity-75">
            Soluciones tecnológicas personalizadas para tu negocio
          </p>
        </div>
      </div>
    );
  }

  if (variant === 'about') {
    return (
      <div className={`bg-white border border-gray-200 rounded-lg p-6 shadow-sm ${className}`}>
        <div className="flex items-start space-x-4">
          <div className="bg-blue-100 p-3 rounded-full">
            <Code className="h-6 w-6 text-blue-600" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Desarrollador del Sistema
            </h3>
            <p className="text-gray-600 mb-3">
              Este sistema fue creado completamente por <strong>JOHN ROMAN</strong>, 
              especialista en soluciones tecnológicas empresariales.
            </p>
            <div className="bg-gray-50 p-4 rounded-lg">
              <h4 className="font-medium text-gray-900 mb-2">
                🏢 Tu Lugar Inteligente
              </h4>
              <p className="text-sm text-gray-600 mb-3">
                Transformamos tu negocio con tecnología de vanguardia. 
                Sistemas web personalizados, automatización y soluciones en la nube.
              </p>
              <div className="flex items-center justify-between">
                <span className="text-sm text-gray-500">
                  📧 Contacto directo:
                </span>
                <a 
                  href="tel:931398916" 
                  className="flex items-center space-x-1 text-green-600 hover:text-green-700 font-medium"
                >
                  <Phone className="h-4 w-4" />
                  <span>931398916</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Variant 'footer' (default)
  return (
    <div className={`text-center py-2 px-4 ${className}`}>
      <div className="flex items-center justify-center text-sm text-gray-600 space-x-2">
        <Monitor className="h-4 w-4 text-blue-500" />
        <span className="font-medium text-blue-600">
          Creado por JOHN ROMAN - Tu Lugar Inteligente
        </span>
        <span>•</span>
        <a 
          href="tel:931398916" 
          className="text-green-600 hover:text-green-700 font-medium transition-colors flex items-center space-x-1"
        >
          <Phone className="h-3 w-3" />
          <span>931398916</span>
        </a>
      </div>
    </div>
  );
};

export default MarcaPersonal;